/**
 * Hamburger Toggle in SP
 */
import updateSelect from '../../imports/customSelectToggler';

const customSelect = () => {
  const selectField = document.querySelectorAll('.js-customSelect');

  if (selectField.length > 0) {
    selectField.forEach(selectFieldItem => {
      if (selectFieldItem) {
        let itemValueDisplay = selectFieldItem.querySelector('.js-customSelect-value');
        let itemList = selectFieldItem.querySelector('.js-customSelect-content');
        let wrapper = selectFieldItem.querySelector('.js-customSelect-wrapper') as HTMLElement;

        // Dropdown selection
        if (itemValueDisplay) {
          itemValueDisplay.addEventListener('click', function () {
            let itemContent = selectFieldItem.querySelector('.js-customSelect-wrapper');
            let itemValues = selectFieldItem.querySelectorAll('.js-customSelect-item');
            
            if (itemValues.length > 0 && itemContent && itemValueDisplay) {
              selectFieldItem.classList.add('active');
    
              itemValues.forEach(itemValuesElement => {
                itemValuesElement.addEventListener('click', function () {
                  let itemValue = itemValuesElement.getAttribute('value') as string;
                  if (itemValue != '' && itemValueDisplay != undefined) {
                    itemValueDisplay.innerHTML = itemValue;
                    selectFieldItem.classList.remove('active');
                  }

                });

                window.addEventListener('click', function (e) {
                  if (e.target !== itemValueDisplay) {
                    selectFieldItem.classList.remove('active');
                  }
                });
              });
            }

            selectField.forEach(element => {
              if ( element != selectFieldItem ) {
                element.classList.remove('active');
              }
            });

            if (wrapper) {
              updateSelect(wrapper);
            }
          });
        }

        if (itemList) {
          if (wrapper) {
            updateSelect(wrapper);

            itemList.addEventListener('scroll', function () {
              updateSelect(wrapper);
            });
          }
        }
      }
    });

    // new SimpleBar(selectList, { autoHide: false } ).getScrollElement().addEventListener('scroll', function(event:any) {
    //   const { scrollHeight, scrollTop, clientHeight } = event.target;
    //   const isBottomReached = (scrollHeight - Math.round(scrollTop) === clientHeight);
    //   const isTopReached = (scrollHeight + Math.round(scrollTop) === clientHeight);
    //   let wrapper = document.querySelector('.js-customSelect-wrapper');

    //   console.log(isTopReached);

    //   if (isBottomReached == true) {
    //     wrapper?.classList.add('upper');
    //     wrapper?.classList.remove('bottom');
    //   } else {
    //     wrapper?.classList.add('upper');
    //     wrapper?.classList.add('bottom');
    //   }
    // });
  }
};

export default customSelect;
